<template>
  <section class="monospace">{{ title }}</section>
</template>

<script setup>
defineProps({
  title: String
})
</script>

<style scoped>
section {
  background-color:darkslategrey;
  height: 100vh;
  text-align: center;
  display: flex;
	flex-direction: column;
	justify-content: center;
  font-size: xx-large;
  color: white;
}

h1 {
  font-family: monospace
}

#monospace {
  font-family: monospace;
}

@media (max-width: 1000px) {
  section {
    width: 96vw;
  }
}

@media (min-width: 1001px) {
  section {
    width: 99vw;
  }
}
</style>